/*
  Mobile menu (snippets/nav-drawer.liquid): shows the head's and the foot's
  edge shadows only when links are actually scrolled behind them.
  - data-scrolled on the card: the links are scrolled down (head shadow).
  - data-more on the card: there's more to scroll below (foot shadow).
  Also keeps the groups an accordion (one open at a time) and animates them
  opening and closing.
  Opening/closing the drawer stays with assets/header.js.
*/
(function () {
  function update(scroller) {
    var card = scroller.closest('.mobile-menu__card');
    if (!card) return;

    card.toggleAttribute('data-scrolled', scroller.scrollTop > 2);
    card.toggleAttribute('data-more', scroller.scrollTop + scroller.clientHeight < scroller.scrollHeight - 2);
  }

  // `scroll` doesn't bubble, so listen in the capture phase.
  document.addEventListener(
    'scroll',
    function (event) {
      var scroller = event.target;
      if (scroller instanceof Element && scroller.matches('.mobile-menu__scroll')) update(scroller);
    },
    { capture: true, passive: true }
  );

  // Re-measure whenever the scroll area changes size: the drawer opening
  // (display: none -> visible), a group opening/closing, rotation.
  function observe() {
    var scroller = document.querySelector('[data-mobile-menu] .mobile-menu__scroll');
    if (!scroller) return;

    update(scroller);
    if (typeof ResizeObserver === 'function') {
      var observer = new ResizeObserver(function () {
        update(scroller);
      });
      observer.observe(scroller);
      Array.prototype.forEach.call(scroller.children, function (child) {
        observer.observe(child);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  /*
    Smooth open/close: the group's links grow from / shrink to zero height
    instead of jumping. <details> can't transition its own content in Safari,
    so the summary tap is handled here and the links are animated with the
    Web Animations API; the group only really closes (open = false) once its
    links have shrunk away. Opening one group shrinks the open one at the
    same time. A tap mid-animation reverses from the current height.
  */
  var GROUP_SELECTOR = '[data-mobile-menu] details.mobile-menu__group';
  var DURATION = 320;
  var EASING = 'cubic-bezier(0.32, 0.72, 0, 1)';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function stop(group) {
    if (group._mmAnimation) {
      group._mmAnimation.onfinish = null;
      group._mmAnimation.cancel();
      group._mmAnimation = null;
    }
    group.classList.remove('mobile-menu__group--closing');
  }

  function animateGroup(group, opening) {
    var content = group.querySelector('.mobile-menu__sublinks');
    var from = content && group.open ? content.getBoundingClientRect().height : 0;
    stop(group);

    if (!content || typeof content.animate !== 'function' || (reduceMotion && reduceMotion.matches)) {
      group.open = opening;
      return;
    }

    group.open = true;
    var to = opening ? content.getBoundingClientRect().height : 0;
    if (!opening) group.classList.add('mobile-menu__group--closing');

    var animation = content.animate(
      [
        { height: from + 'px', opacity: opening ? (from ? 1 : 0) : 1, overflow: 'hidden' },
        { height: to + 'px', opacity: opening ? 1 : 0, overflow: 'hidden' }
      ],
      { duration: DURATION, easing: EASING }
    );
    group._mmAnimation = animation;
    animation.onfinish = function () {
      group._mmAnimation = null;
      group.classList.remove('mobile-menu__group--closing');
      if (!opening) group.open = false;
    };
  }

  function isOpen(group) {
    return group.open && !group.classList.contains('mobile-menu__group--closing');
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('summary');
    var group = summary && summary.parentElement;
    if (!group || !group.matches(GROUP_SELECTOR) || summary !== group.querySelector('summary')) return;

    event.preventDefault();
    var opening = !isOpen(group);
    if (opening) {
      document.querySelectorAll(GROUP_SELECTOR).forEach(function (other) {
        if (other !== group && isOpen(other)) animateGroup(other, false);
      });
    }
    animateGroup(group, opening);
  });

  // The browser's own exclusive accordion (name="") would close the other
  // group instantly, cutting its animation short - the click handler above
  // keeps one open at a time instead. name="" stays in the markup for when
  // this script doesn't run.
  function dropNames() {
    document.querySelectorAll(GROUP_SELECTOR + '[name]').forEach(function (group) {
      group.removeAttribute('name');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', dropNames);
  } else {
    dropNames();
  }
})();
